const error404 = {
    title: 'Error 404',
    header: '404',
    description: 'We can’t seem to find the page you’re looking for.',
    contactUs: 'If the problem persists, contact us here: info@extrapole.ca',
}

export default error404
